import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { Marcas, MarcasSend } from '../_model/marcas';
import { Media } from '../_model/media';
import { Tipo } from '../_model/tipo';
import { MarcasService } from '../_services/marcas.service';
import { faPencilAlt, faTrash } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-insertMarca',
    templateUrl: './insertMarca.component.html',
    styleUrls: ['./insertMarca.component.less'],
    standalone: false
})
export class InsertMarcaComponent implements OnInit {

  faPencilAlt = faPencilAlt;
  faTrash = faTrash;

  constructor(private marca: MarcasService) { }

  marcaSel: Marcas = new Marcas();

  itemMarca: MarcasSend = new MarcasSend();

  marcas: Marcas[] = [];

  activate: boolean = false;

  apiUrl: string = environment.apiUrl;

  tipo: Tipo[] = [

    new Tipo({
      key: "alta",
      name: "Alta Relojoaria"
    }),
    new Tipo({
      key: "relogio",
      name: "Relojoaria"
    }),
    new Tipo({
      key: "j1",
      name: "Joalharia"
    }),
    new Tipo({
      key: "j2",
      name: "Pratas"
    }),
    new Tipo({
      key: "acess",
      name: "Acessórios"
    }),
    new Tipo({
      key: "noiva",
      name: "Noivas"
    })
  ];

  selTipo: Tipo[] = [];

  ngOnInit() {
    this.marca.list().subscribe((data: any[]) => {
      data.forEach(el => {
        this.marcas.push(new Marcas(el));
      });
    });
    this.itemMarca.userId = localStorage.getItem("userId");
  }

  clear() {
    this.itemMarca = new MarcasSend();
    this.selTipo = [];
    this.itemMarca.userId = localStorage.getItem("userId");
  }


  getMarca(id): Marcas {
    return this.marcas.filter(x => x.id == id)[0];
  }

  bindMarca(item: Marcas) {
    this.itemMarca.id = item.id;
    this.itemMarca.nome = item.nome;
    this.itemMarca.userId = localStorage.getItem("userId");
    this.itemMarca.tipo = item.tipo;
    this.itemMarca.link = item.link;
    this.selTipo = [];
    this.itemMarca.tipo = item.tipo;
    var t = item.tipo.split(";").filter(x => x != '');
    t.forEach(it => {
      this.selTipo.push(new Tipo(this.tipo.filter(x => x.key.includes(it))[0]));
    });
    this.marca.getMediaRaw(item.id).subscribe((data: any) => {
      this.itemMarca.media = [];
      data.forEach(el => {
        this.itemMarca.media.push(new Media(el));
      });
    });
  }

  deleteMarca(item: Marcas) {
    Swal.fire({
      title: "Tem a certeza que pretende eliminar a marca?",
      html: "<p>Se continuar com esta ação irá eliminar a marca  "+item.nome+" da base de dados,</p><h1 class='textColor red base'>ASSIM COMO TODOS OS PRODUTOS ASSOCIADOS A MESMA</h1>",
      icon: 'warning',
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar',
      showCancelButton: true,
      customClass: {
        confirmButton: "btn red base",
        cancelButton: "btn green base"
      }
    }).then((result) => {
      if(result.isConfirmed) {
        Swal.fire({
          title: "Marca Eliminada com sucesso",
          text: "A marca "+item.nome+" foi eliminada da base de dados, assim como todos os produtos a ela associados",
          icon: 'success'
        });
        this.marca.delete(item.id, localStorage.getItem("userId")).subscribe(() => {
          this.itemMarca = new MarcasSend();
          this.marcas = [];
          this.selTipo = [];
          this.marca.list().subscribe((data: any[]) => {
            data.forEach(el => {
              this.marcas.push(new Marcas(el));
            });
          });
          this.itemMarca.userId = localStorage.getItem("userId");
        });
      }
    });
  }

  sendMarca() {
    this.itemMarca.tipo = "";
    this.activate = false;
    this.selTipo.forEach(it => {
      this.itemMarca.tipo += it.key+";";
    });
    this.itemMarca.link = this.itemMarca.link.replaceAll("https://","").replaceAll("http://","").replaceAll("http","").replaceAll("https:","").replaceAll("http:","").replaceAll("https","").replaceAll("://","").replaceAll("//","").replaceAll(" ","");
    if(this.itemMarca.nome == '') {
      Swal.fire({
        title: "<h1 class='textColor harvest-gold base'>Falta o nome da Marca</h1>",
        icon: 'warning',
        customClass: {
          popup: 'card-border-gold',
        }
      });
    }else if(this.itemMarca.tipo == ''){
      Swal.fire({
        title: "<h1 class='textColor harvest-gold base'>Faltam os tipos da Marca</h1>",
        icon: 'warning',
        customClass: {
          popup: 'card-border-gold',
        }
      });
    }else if(this.itemMarca.media.length == 0){
      Swal.fire({
        title: "<h1 class='textColor harvest-gold base'>Falta imagem da Marca</h1>",
        icon: 'warning',
        customClass: {
          popup: 'card-border-gold',
        }
      });
    }else {
      this.marca.send(this.itemMarca).subscribe(() => {
        this.selTipo = [];
        this.marcas = [];
        this.marca.list().subscribe((data: any[]) => {
          data.forEach(el => {
            this.marcas.push(new Marcas(el));
          });
        });
        if(this.itemMarca.id > 0) {
          Swal.fire({
            title: "<h1 class='textColor harvest-gold base'>Marca actualizada com sucesso</h1>",
            icon: 'success',
            position: 'top-end',
            timer: 1500,
            showConfirmButton:false,
            customClass: {
              popup: 'card-border-gold',
            }
          });
        }else{
          Swal.fire({
            title: "<h1 class='textColor harvest-gold base'>Marca inserida com sucesso</h1>",
            icon: 'success',
            position: 'top-end',
            timer: 1500,
            showConfirmButton:false,
            customClass: {
              popup: 'card-border-gold',
            }
          });
        }
        this.clear();
      });
    }
  }

  sendConfirmation() {
    Swal.fire({
      title: (this.activate ? "Desativou":"Ativou") + " a edição do link externo",
      icon: "warning",
      timer: 1500
    });
  }

}
